export class FileConstants {
  public static imageExtensions: string[] = ['tiff', 'jpg', 'jpeg', 'png'];
  public static documentExtension: string[] = ['doc', 'docx', 'odt'];
  public static pdfExtension: string[] = ['pdf'];
  public static excelExtensions: string[] = ['xsl', 'xlsx'];
}
